<script setup>
import { HrIcon, HrStatusActionChip, HrTooltip } from 'src/design-system';
import { network as networkStore } from 'src/store/network';
import { computed } from 'vue';

defineOptions({ name: 'OfflineModeIndicator' });

defineProps({
  warningVisible: { type: Boolean, default: false },
  successVisible: { type: Boolean, default: false },
  enableOfflineModeDialog: { type: Boolean, default: false },
  noLabel: { type: Boolean, default: false },
});

const emit = defineEmits(['update:warningVisible', 'update:successVisible']);

const network = networkStore();

const networkOnline = computed(() => network.networkOnline);
const offlineMode = computed(() => network.offlineMode);
</script>

<template>
  <hr-icon
    v-if="!networkOnline && !enableOfflineModeDialog"
    name="signal_wifi_off"
    size="sm"
    :legacy-props="{ color: 'white', size: 'xs' }"
    data-e2e="icon-no-connection"
  >
    <hr-tooltip>{{ $t('common.isOfflineTooltip') }}</hr-tooltip>
  </hr-icon>
  <hr-status-action-chip
    v-else-if="!networkOnline && !offlineMode"
    :model-value="warningVisible"
    icon="cloud_off"
    size="sm"
    chevron
    :label="noLabel ? '' : $t('common.workOfflineToggle')"
    data-e2e="chip-work-offline"
    @update:model-value="emit('update:warningVisible', $event)"
  />
  <hr-icon
    v-else-if="!networkOnline && offlineMode"
    name="offline_bolt"
    size="md"
    :legacy-props="{ color: 'white', size: 'sm' }"
    data-e2e="icon-offline-mode-active"
  >
    <hr-tooltip>{{ $t('common.offlineModeEnabledTooltip') }}</hr-tooltip>
  </hr-icon>
  <hr-status-action-chip
    v-else-if="offlineMode"
    :model-value="successVisible"
    icon="cloud_sync"
    size="sm"
    chevron
    :label="noLabel ? '' : $t('common.switchOnlineToggle')"
    data-e2e="chip-switch-online"
    @update:model-value="emit('update:successVisible', $event)"
  />
</template>
